import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, Grid, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, Divider, Alert, CircularProgress, Collapse, IconButton, TableFooter, TablePagination, useTheme, AlertTitle, Pagination } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../globalhelper/helper";
import { useDispatch } from "react-redux";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { hideLoader, showAlert, showLoader } from "../../redux/Common/commonActions";
import { CSVLink } from "react-csv";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { GetApp } from "@mui/icons-material";
import DialougeBox from "../VR2_Form_Rendering/DialougeBox";
import { LoadingButton } from "@mui/lab";
import { styled } from "@material-ui/styles";
import { useRef } from "react";
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});
Row.propTypes = {
  row: PropTypes.shape({
    Date: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    "Voucher Number": PropTypes.number.isRequired,
    "Voucher Ref Date": PropTypes.number.isRequired,
    "Ledger Name": PropTypes.number.isRequired,
    remarks: PropTypes.number.isRequired,
    "Debit / Credit": PropTypes.number.isRequired,
    "Bill Ref No": PropTypes.number.isRequired,
    Amount: PropTypes.number.isRequired,
    "Cost Center": PropTypes.number.isRequired,
    QTY: PropTypes.number.isRequired,
    Rate: PropTypes.number.isRequired,
    UOM: PropTypes.number.isRequired,
    "Item Amount": PropTypes.number.isRequired,
    Narration: PropTypes.number.isRequired,
    details: PropTypes.arrayOf(PropTypes.shape({
      Date: PropTypes.number.isRequired,
      status: PropTypes.number.isRequired,
      "Voucher Number": PropTypes.number.isRequired,
      "Voucher Ref Date": PropTypes.number.isRequired,
      "Ledger Name": PropTypes.number.isRequired,
      remarks: PropTypes.number.isRequired,
      "Debit / Credit": PropTypes.number.isRequired,
      "Bill Ref No": PropTypes.number.isRequired,
      Amount: PropTypes.number.isRequired,
      "Cost Center": PropTypes.number.isRequired,
      QTY: PropTypes.number.isRequired,
      Rate: PropTypes.number.isRequired,
      UOM: PropTypes.number.isRequired,
      "Item Amount": PropTypes.number.isRequired,
      Narration: PropTypes.number.isRequired
    })).isRequired
  }).isRequired
};
function Row({
  key,
  row,
  selectedItems,
  handleCheckboxChange
}) {
  return <React.Fragment>
    <TableRow key={key} sx={{
      backgroundColor: selectedItems.includes(row["Voucher Number"]) ? "#a0d3ff" : "transparent"
    }}>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        <Checkbox disabled={row.status === "Success"} type="checkbox" checked={selectedItems.includes(row["Voucher Number"])} onClick={() => {
          handleCheckboxChange(row["Voucher Number"]);
        }} />
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Date"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["status"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Voucher Number"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Voucher Ref No"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Voucher Ref Date"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Voucher Type"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Ledger Name"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["remarks"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Debit / Credit"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Bill Ref No"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Amount"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Cost Center"]}
      </TableCell>
      {/* <TableCell sx={{ pt: 0, pb: 0, whiteSpace: 'nowrap' }}>
                    {row['Stock Item']}
                  </TableCell>
                  <TableCell sx={{ pt: 0, pb: 0, whiteSpace: 'nowrap' }}>
                    {row['Godown']}
                  </TableCell>
                  <TableCell sx={{ pt: 0, pb: 0, whiteSpace: 'nowrap' }}>
                    {row['Batch No']}
                  </TableCell> */}
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["QTY"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Rate"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["UOM"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Item Amount"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["Narration"]}
      </TableCell>
      <TableCell sx={{
        pt: 0,
        pb: 0,
        whiteSpace: "nowrap"
      }}>
        {row["System Remarks"]}
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell style={{
        paddingBottom: 0,
        paddingTop: 0
      }} colSpan={14}>
        <Collapse in={selectedItems.includes(row["Voucher Number"])} timeout="auto" unmountOnExit>
          <Box sx={{
            margin: 1
          }}>
            <Table size="small" aria-label="purchases">
              <TableBody>
                {row.details?.map((item, index) => <TableRow key={index} sx={{
                  backgroundColor: selectedItems.includes(row["Voucher Number"]) ? "#a0d3ff" : "transparent"
                }}>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Date"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["status"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Voucher Number"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Voucher Ref No"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Voucher Ref Date"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Voucher Type"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Ledger Name"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["remarks"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Debit / Credit"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Bill Ref No"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap",
                    textAlign: "right"
                  }}>
                    {item["Amount"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Cost Center"]}
                  </TableCell>
                  {/* <TableCell sx={{ pt: 0, pb: 0, whiteSpace: 'nowrap' }}>
                        {item['Stock Item']}
                       </TableCell>
                       <TableCell sx={{ pt: 0, pb: 0, whiteSpace: 'nowrap' }}>
                        {item['Godown']}
                       </TableCell>
                       <TableCell sx={{ pt: 0, pb: 0, whiteSpace: 'nowrap' }}>
                        {item['Batch No']}
                       </TableCell> */}
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["QTY"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Rate"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["UOM"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Item Amount"]}
                  </TableCell>
                  <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap"
                  }}>
                    {item["Narration"]}
                  </TableCell>
                </TableRow>)}
                <TableRow>
                  <TableCell colSpan={9}></TableCell>
                  <TableCell sx={{
                    fontWeight: "bold"
                  }}>Diffrence</TableCell>
                  <TableCell sx={{
                    textAlign: "right"
                  }}>
                    {row["details"].filter((item, index, self) => index === self.findIndex(i => i["Ledger Name"] === item["Ledger Name"])).reduce((sum, accum) => {
                      return parseFloat(accum?.["Amount"]) + sum;
                    }, 0).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  </React.Fragment>;
}
export default function TallyIntegratinV2() {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    ledgerType: null,
    fromDate: null,
    toDate: null,
    company: null
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [dropDown, setDropDown] = useState({
    parentName: [],
    primaryGroup: []
  });
  const [missingLedgers, setMissingLedgers] = useState([]);
  const [dialog, setDialog] = useState(null);
  let [reports, setReports] = useState([]);
  let [filteredRows, setfilteredRows] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [ledgerTypes, setLedgerTypes] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    fetchCompanies();
  }, []);
  const fileInputRef = useRef(null);
  const handleFileUpload = async e => {
    try {
      if (!e.target.files || e.target.files.length === 0) return;
      setLoading(true);
      const APIformData = new FormData();
      const file = e.target.files[0];
      APIformData.append("file", file);
      APIformData.append("ForPrdFrom", formData.fromDate || "");
      APIformData.append("ForPrdTo", formData.toDate || "");
      try {
        const {
          res
        } = await postRequest(`api/upload/handleVoucherReconciliation?OrgID=${formData?.company?.orgid || ""}&KEY=pretransaction/Integration/${formData.ledgerType?.value}/${formData.ledgerType?.value}`, APIformData);
        console.log("Upload Success:", res);
        if (res.status === "success") {
          handleFormSubmit();
        }
      } catch (error) {
        console.error("Upload Error:", error);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      // ✅ Clear file input manually via ref
      if (fileInputRef.current) fileInputRef.current.value = null;
    }
  };
  function createData(item, filteredJournals = []) {
    console.log(filteredJournals, item);
    return {
      Date: item.Date,
      status: item.status,
      "Voucher Number": item["Voucher Number"],
      "Voucher Ref No": item["Voucher Ref No"],
      "Voucher Ref Date": item["Voucher Ref Date"],
      "Voucher Type": item["Voucher Type"],
      "Ledger Name": item["Ledger Name"],
      remarks: item.remarks,
      "Debit / Credit": item["Debit / Credit"],
      "Bill Ref No": item["Bill Ref No"],
      Amount: item.Amount,
      "Cost Center": item["Cost Center"],
      QTY: item.QTY,
      Rate: item.Rate,
      UOM: item.UOM,
      "Item Amount": item["Item Amount"],
      Narration: item.Narration,
      "System Remarks": item["systemremarks"],
      // nested details
      details: filteredJournals.map(j => ({
        Date: j.Date,
        status: j.status,
        "Voucher Number": j["Voucher Number"],
        "Voucher Ref No": j["Voucher Ref No"],
        "Voucher Ref Date": j["Voucher Ref Date"],
        "Voucher Type": j["Voucher Type"],
        "Ledger Name": j["Ledger Name"],
        remarks: j.remarks,
        "Debit / Credit": j["Debit / Credit"],
        "Bill Ref No": j["Bill Ref No"],
        Amount: j.Amount,
        "Cost Center": j["Cost Center"],
        QTY: j.QTY,
        Rate: j.Rate,
        UOM: j.UOM,
        "Item Amount": j["Item Amount"],
        Narration: j.Narration
      })) || []
    };
  }
  const fetchCompanies = async () => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data;
      setCompanies(responseData);
      if (responseData?.length === 1) setFormData(prev => ({
        ...prev,
        company: responseData[0]
      }));
    }).catch(err => console.log(err));
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData(prev => ({
      ...prev,
      fromDate: firstDay,
      toDate: lastDay
    }));
  };
  const handleFormSubmit = async e => {
    e?.preventDefault();
    dispatch(showLoader());
    setReports([]);
    try {
      const payload = {
        ledgerType: formData.ledgerType?.value,
        fromDate: formData.fromDate ? moment(formData.fromDate).format("YYYY-MM-DD") : "",
        toDate: formData.toDate ? moment(formData.toDate).format("YYYY-MM-DD") : "",
        orgId: formData.company.orgid
      };
      let {
        res
      } = await postRequest(`api/edureka/tallyIntegrations`, payload);
      if (JSON.parse(res?.data)?.length === 0) {
        setMessage(<Box style={{
          margin: "auto"
        }}>
          <Alert severity="warning">
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display at the moment.
          </Alert>
        </Box>);
        return;
      }
      if (res.status === "failed") {
        setMessage(<Box style={{
          margin: "auto"
        }}>
          <Alert severity="error">
            <AlertTitle>Opps Error Occured!</AlertTitle>
            There is an error occurred while fetching data.
          </Alert>
        </Box>);
        return;
      }
      setMessage(null);
      let parsedData = await JSON.parse(res.data).sort((a, b) => a["Voucher Number"].localeCompare(b["Voucher Number"]));
      setReports(parsedData);
      console.log(parsedData, parsedData.sort((a, b) => a["Voucher Number"].localeCompare(b["Voucher Number"]))?.filter(d => d["Debit / Credit"] === "Cr" && d["Item Amount"] === "0.00" && (d["Voucher Type"] == "DT-Purchase" || d["Voucher Type"] == "DT-Payment") || d["Debit / Credit"] === "Dr" && d["Item Amount"] === "0.00" && (d["Voucher Type"] == "Debit Note" || d["Voucher Type"] == "DT-Payment")));
      let filteredData = parsedData.sort((a, b) => a["Voucher Number"].localeCompare(b["Voucher Number"]))?.filter(d => d["Debit / Credit"] === "Cr" && d["Item Amount"] === "0.00" && (d["Voucher Type"] == "DT-Purchase" || d["Voucher Type"] == "DT-Payment") || d["Debit / Credit"] === "Dr" && d["Item Amount"] === "0.00" && (d["Voucher Type"] == "Debit Note" || d["Voucher Type"] == "DT-Payment")).filter((d, index, self) => self.findIndex(i => i["Voucher Number"] === d["Voucher Number"]) === index);
      console.log(filteredData);
      setDropDown(prev => ({
        ...prev,
        ledgername: [...new Set(filteredData.map(item => item["Ledger Name"]))],
        invoiceref: [...new Set(filteredData.map(item => item["Voucher Ref No"]))],
        status: [...new Set(filteredData.map(item => item["status"]).filter(item => item))]
      }));
      setRows(filteredData?.map(item => {
        let filteredJournals = parsedData.length > 0 && parsedData.filter(data => data["Voucher Number"] === item["Voucher Number"] && data["Voucher Ref No"] === item["Voucher Ref No"]).sort((a, b) => {
          const getPriority = row => {
            if (row["Debit / Credit"] === "Cr" && row["Ledger Name"]?.includes("Rounding Off")) return 3;
            if (row["Debit / Credit"] === "Cr") return 1;
            return 2;
          };
          const priorityA = getPriority(a);
          const priorityB = getPriority(b);
          if (priorityA !== priorityB) return priorityA - priorityB;
          return parseFloat(b["Amount"]) - parseFloat(a["Amount"]);
        }) || [];
        return createData(item, filteredJournals);
      }));
      setfilteredRows(filteredData?.map(item => {
        let filteredJournals = parsedData.length > 0 && parsedData.filter(data => data["Voucher Number"] === item["Voucher Number"] && data["Voucher Ref No"] === item["Voucher Ref No"]).sort((a, b) => {
          const getPriority = row => {
            if (row["Debit / Credit"] === "Cr" && row["Ledger Name"]?.includes("Rounding Off")) return 3;
            if (row["Debit / Credit"] === "Cr") return 1;
            return 2;
          };
          const priorityA = getPriority(a);
          const priorityB = getPriority(b);
          if (priorityA !== priorityB) return priorityA - priorityB;

          // If same priority, sort by amount (descending)
          return parseFloat(b["Amount"]) - parseFloat(a["Amount"]);
        }) || [];
        return createData(item, filteredJournals);
      }));
    } catch (error) {
      console.error("Error during Tally Integration:", error);
    } finally {
      dispatch(hideLoader());
    }
  };
  useEffect(() => {
    if (formData.company?.orgid && formData.company?.orgid !== "") {
      getRequest(`api/edureka/getLedgerNameForTally?companycode=${formData.company.orgid} `).then(response => {
        if (response.res.data) {
          const data = JSON.parse(response.res.data);
          const tempParentName = data.filter(item => item !== undefined).map(item => item?.["Parent Name"]);
          const tempPrimaryGroup = data.filter(item => item !== undefined).map(item => item?.["Primary Group"]);
          setDropDown({
            parentName: [...new Set(tempParentName)],
            primaryGroup: [...new Set(tempPrimaryGroup)]
          });
        }
      });
      let Module = localStorage.getItem("module");
      getRequest(
        `api/edureka/getS3ObjectList?Module=${Module} `
      ).then((response) => {
        if (response.res.data) {
          const data = JSON.parse(response.res.data);
          const tempLedgerTypes = data.filter(item => item !== undefined).map(item => ({
            label: item,
            value: item
          }));
          setLedgerTypes(tempLedgerTypes);
        }
      });
    }
  }, [formData.company?.orgid]);
  const handleItemSelect = (val, e) => {
    const {
      name,
      value
    } = e.target;
    const data = [...missingLedgers];
    const mappedData = data.map((item, index) => {
      if (item["Ledger Name"] === val["Ledger Name"]) {
        return {
          ...item,
          [name]: value
        };
      } else {
        return item;
      }
    });
    setMissingLedgers(mappedData);
  };
  useEffect(() => {
    setPage(0);
    let filteredData = rows.filter(row => {
      return (formData.ledgername === row["Ledger Name"] || formData.ledgername === null || formData.ledgername === undefined || formData.ledgername === "") && (formData.invoiceref === row["Voucher Ref No"] || formData.invoiceref === null || formData.invoiceref === undefined || formData.invoiceref === "") && (formData.status === row["status"] || formData.status === null || formData.status === undefined || formData.status === "");
    });
    setfilteredRows(filteredData);
    return;
  }, [formData.ledgername, formData.invoiceref, formData.status]);
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectedRowData([]);
      setMissingLedgers([]);
    } else {
      // Select all items except those with status 'Initiated' or 'Success'
      const selectableItems = reports.filter(item => item.status !== "Initiated" && item.status !== "Success");
      setSelectedRowData(selectableItems);
      setSelectedItems(selectableItems.map(item => item["Voucher Number"]));
      setMissingLedgers(reports.filter(item => item.remarks === "Missing Ledger"));
      setOpenDialouge(true);
    }
    setSelectAll(!selectAll);
  };
  const handleCheckboxChange = index => {
    const selected = [...selectedItems];
    if (selected.includes(index)) {
      selected.splice(selected.indexOf(index), 1);
      setMissingLedgers(prev => prev.filter(item => item !== index));
      setSelectedRowData(prev => prev.filter(item => item["Voucher Number"] !== index));
    } else {
      selected.push(index);
      let filteredItem = reports.filter(item => item["Voucher Number"] === index && item.remarks === "Missing Ledger");
      let filterSelectedItems = reports.filter(item => item["Voucher Number"] === index);
      setMissingLedgers(prev => [...prev, ...filteredItem]);
      setSelectedRowData(prev => [...prev, ...filterSelectedItems]);
      setOpenDialouge(true);
    }
    setSelectedItems(selected);
  };
  const [openDialouge, setOpenDialouge] = useState(false);
  const handleCloseDialouge = () => {
    setSelectAll(false);
    setSelectedItems([]);
    setSelectedRowData([]);
    setMissingLedgers([]);
    setMissingLedgers([]);
    setOpenDialouge(false);
  };
  const handleCreateLedgerMaster = async () => {
    try {
      let response = await postRequest("api/edureka/postMasterLedger", {
        items: missingLedgers,
        company: formData.company
      });
      if (response.type === "success") {
        setOpenDialouge(false);
        handleFormSubmit();
        setMissingLedgers([]);
      }
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };
  const handlePushToERP = async (checkFlag = true) => {
    try {
      setDialog(null);
      if (checkFlag) {
        let rowsAlreadyPushed = reports.filter(item => selectedItems.includes(item?.["Voucher Number"]) && item?.["status"] === "Initiated");
        if (rowsAlreadyPushed.length > 0) {
          setDialog(<DialougeBox status={"warning"} message={`The following rows are already pushed to ERP: ${[...new Set(rowsAlreadyPushed.map(item => item["Voucher Ref No"]))].join(", ")}. Are you sure about push this again?`} onClose={() => setDialog(null)} operation={() => handlePushToERP(false)} />);
          return;
        }
      }
      setDisableButton(true);
      let response = await postRequest(`api/edureka/handlePushToERP?transType=${formData.ledgerType?.value}`, {
        company: formData.company,
        selectedItems,
        items: reports
      });
      if (response.res.status === "success") {
        setSelectedItems([]);
        handleFormSubmit();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDisableButton(false);
    }
  };
  const handleReset = () => {
    setSelectAll(false);
    setSelectedItems([]);
    setSelectedRowData([]);
    setMissingLedgers([]);
    setFormData({
      company: null,
      ledgername: null,
      invoiceref: null,
      ledgerType: null,
      status: null
    });
  };
  return <Box>
    {missingLedgers.length > 0 && <Dialog open={openDialouge} onClose={handleCloseDialouge} maxWidth="md" fullWidth>
      <DialogTitle>Oops! An Error Occurred</DialogTitle>
      <DialogContent dividers>
        <Alert severity={"error"}>
          Below ledgers are missing these might not created in tally
          <List dense>
            {missingLedgers?.map((item, index) => <React.Fragment key={index}>
              <Grid container spacing={2}>
                <Grid item xl={2}>
                  <ListItem>
                    <ListItemText primary={item["Ledger Name"]} />
                  </ListItem>
                </Grid>

                <Grid item xl={4}>
                  {" "}
                  {item.remarks === "Missing Ledger" ? <Tooltip title={item.parentName || ""}>
                    <TableCell sx={{
                      p: 0.2,
                      whiteSpace: "nowrap",
                      maxWidth: "200px"
                    }}>
                      <Select sx={{
                        width: "200px"
                      }} fullWidth variant="outlined" name="parentName" value={item.parentName || ""} onChange={e => handleItemSelect(item, e)} required>
                        <MenuItem value="" disabled>
                          Select
                        </MenuItem>
                        {dropDown.parentName.sort().map((item, index) => <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>)}
                      </Select>
                    </TableCell>
                  </Tooltip> : <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap",
                    maxWidth: "300px"
                  }}></TableCell>}{" "}
                </Grid>
                <Grid item xl={4}>
                  {item.remarks === "Missing Ledger" ? <Tooltip title={item.primaryGroup || ""}>
                    <TableCell sx={{
                      p: 0.2,
                      whiteSpace: "nowrap",
                      maxWidth: "200px"
                    }}>
                      <Select sx={{
                        width: "200px"
                      }} fullWidth variant="outlined" name="primaryGroup" value={item.primaryGroup || ""} onChange={e => handleItemSelect(item, e)} required>
                        <MenuItem value="" disabled>
                          Select
                        </MenuItem>
                        {dropDown.primaryGroup.sort().map((item, index) => <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>)}
                      </Select>
                    </TableCell>
                  </Tooltip> : <TableCell sx={{
                    pt: 0,
                    pb: 0,
                    whiteSpace: "nowrap",
                    Width: "400px"
                  }}></TableCell>}
                </Grid>
              </Grid>
            </React.Fragment>)}
          </List>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCreateLedgerMaster} variant="contained" color="success">
          Add Ledgers
        </Button>{" "}
        <Button onClick={handleCloseDialouge} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>}
    <Accordion defaultExpanded sx={{
      position: "sticky  "
    }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Search</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container columns={12} spacing={2}>
          <Grid item xs={1} sm={2} md={3}>
            <Autocomplete size="small" fullWidth options={companies || []} value={formData?.company || null} getOptionLabel={option => option.orgname} isOptionEqualToValue={(option, value) => option?.orgname === value?.orgname} onChange={(event, option) => setFormData(prev => ({
              ...prev,
              company: option ? option : ""
            }))} renderInput={params => <TextField {...params} label="Company Name" variant="outlined" />} />
          </Grid>
          <Grid item xs={1} sm={2} md={2}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="From Date" value={formData?.fromDate} onChange={newValue => setFormData(prev => ({
                ...prev,
                fromDate: newValue
              }))} minDate={moment().subtract(1, "year").startOf("year")} maxDate={moment().endOf("year")} renderInput={params => <TextField fullWidth size="small" {...params} />} />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={1} sm={2} md={2}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="To Date" value={formData?.toDate} onChange={newValue => setFormData(prev => ({
                ...prev,
                toDate: newValue
              }))} minDate={moment().subtract(1, "year").startOf("year")} maxDate={moment().endOf("year")} renderInput={params => <TextField fullWidth size="small" {...params} />} />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete options={ledgerTypes || []} value={formData?.ledgerType || null} onChange={(event, option) => setFormData(prev => ({
              ...prev,
              ledgerType: option
            }))} getOptionLabel={option => option.label || ""} isOptionEqualToValue={(option, value) => option?.value === value?.value} size="small" fullWidth renderInput={params => <TextField {...params} label="Type" variant="outlined" />} />
          </Grid>
          <Grid item xs={3}>
            <Button variant="contained" color="primary" disabled={formData.company === null || formData.toDate === null || formData.fromDate === null || formData.ledgerType === null} onClick={handleFormSubmit}>
              Submit
            </Button>
            &nbsp;
            <Button variant="contained" color="error" onClick={handleReset}>
              Reset
            </Button>
            &nbsp;
            <LoadingButton component="label" loading={loading} loadingPosition="end" variant="contained">
              <FileUploadIcon />
              <VisuallyHiddenInput ref={fileInputRef} accept=".csv, .xls, .xlsx" type="file" onChange={handleFileUpload} multiple={false} />
            </LoadingButton>
            &nbsp;
            {selectedItems.length > 0 && <Button variant="contained" color="warning" disabled={disableButton || selectedItems.length === 0 || missingLedgers.length > 0} onClick={handlePushToERP}>
              {disableButton && <CircularProgress size={20} sx={{
                color: "white"
              }} />}
              &nbsp; Push TO ERP
            </Button>}
          </Grid>
        </Grid>
        {reports.length > 0 && <>
          <Typography variant="h6">Filter</Typography>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete options={dropDown?.ledgername || []} value={formData?.ledgername || null} onChange={(event, option) => setFormData(prev => ({
                ...prev,
                ledgername: option
              }))} size="small" fullWidth renderInput={params => <TextField {...params} label="Ledger Name" variant="outlined" />} />
            </Grid>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete options={dropDown?.invoiceref || []} value={formData?.invoiceref || null} onChange={(event, option) => setFormData(prev => ({
                ...prev,
                invoiceref: option
              }))} size="small" fullWidth renderInput={params => <TextField {...params} label="Invoice Ref" variant="outlined" />} />
            </Grid>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete options={dropDown?.status || []} value={formData?.status || null} onChange={(event, option) => setFormData(prev => ({
                ...prev,
                status: option
              }))} size="small" fullWidth renderInput={params => <TextField {...params} label="Status" variant="outlined" />} />
            </Grid>
          </Grid>
        </>}
      </AccordionDetails>
    </Accordion>
    {reports.length > 0 && <Box align="right" sx={{
      m: 2,
      display: "flex",
      justifyContent: "flex-end",
      flexDirection: "row",
      gap: 2
    }}>
      <Pagination count={Math.ceil(filteredRows.length / rowsPerPage)} page={page + 1} onChange={(event, newPage) => {
        handleChangePage(event, newPage - 1);
      }} variant="outlined" shape="rounded" showFirstButton showLastButton />
      &nbsp;
      <CSVLink size="sm" filename={`Integration_reports${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`} data={reports}>
        <Button variant="contained" color="success">
          <GetApp />
        </Button>
      </CSVLink>
    </Box>}
    {message}
    {dialog}
    {reports.length > 0 && (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Checkbox
                  checked={selectAll}
                  onClick={() => handleSelectAll()}
                />
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Date
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                status
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Voucher Number
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Voucher Ref No
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Voucher Ref Date
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Voucher Type
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Ledger Name
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                remarks
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Debit / Credit
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Bill Ref No
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Amount
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Cost Center
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                QTY
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Rate
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                UOM
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Item Amount
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Narration
              </TableCell>
              <TableCell
                sx={{
                  pt: 0,
                  pb: 0,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                System Remarks
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(filteredRows?.length > 0 &&
              (rowsPerPage > 0
                ? filteredRows.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
                : filteredRows
              ).map((row, rowIndex) => (
                <Row
                  key={page * rowsPerPage + rowIndex}
                  row={row}
                  selectedItems={selectedItems}
                  handleCheckboxChange={handleCheckboxChange}
                />
              ))) || (
                <TableRow>
                  <TableCell colSpan={20} sx={{ p: 5 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                      }}
                    >
                      <Alert severity="error" variant="outlined">
                        No matching records found. Please adjust your search
                        criteria.
                      </Alert>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>

}